<template>
  <div class="freelance-container">
    <span class="freelance-heading">Available 4 projects</span>
    <p v-show="!contactFormSubmitted">
      Seeing some collaboration potential? Let me know if you have any projects in mind.
    </p>

    <p v-show="contactFormSubmitted">
      Thank you for your inquiry, I will get back to you as soon as I can.
    </p>

    <form v-on:submit.prevent="submitContactForm(email)">
        <input required v-model="email" type="email" v-bind:class="{'blinker': email == ''}" placeholder="Email address" />
        <glossy-button
          :disabled="!isValidEmail(email) || contactFormSubmitted"
          :class="isValidEmail(email) && !contactFormSubmitted ? 'purple' : null"
          class="glossy-button">
          {{ (!contactFormSubmitted) ? '📨' : '📫' }}
        </glossy-button>
    </form>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import GlossyButton from './GlossyButton'

export default {
  data: () => ({
    email: ''
  }),
  computed: {
    ...mapState({
      contactFormSubmitted: (state) => state.contacted
    })
  },
  methods: {
    isValidEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    submitContactForm(email) {
      if (!this.contactFormSubmitted && this.isValidEmail(email)) {
        this.$store.dispatch('submitContactForm', { email })
      }
    }
  },
  components: {
    GlossyButton
  }
}
</script>

<style>
.freelance-container {

  text-align: center;
  padding: 30px;
}

.freelance-heading {
  font-size: 19px;
  font-family: Courier New;
  font-weight: bold;
}

.freelance-container p {
  font-size: 15px;
  font-family: Courier New;
}

.freelance-container input {
  border: none;
  text-align: center;
  font-size: 17px;
  height: 30px;
  line-height: 30px;
}

.freelance-container .blinker {
  animation: blinker 2s linear infinite;
}

.freelance-container input:focus {
  animation: none !important;
  opacity: 1;
}

::placeholder {
  color: #ccc;
}

@keyframes blinker {
  20% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// Freelance.vue?5e41f956